export default __webpack_public_path__ + "static/media/img_bg-uefa.6f5c4604.png";